'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);

var _excluded = ["currencySymbol", "decimalPlaces", "decimalSeperator", "onChange", "thousandsSeparator", "value"];
var INTEGER_KEY = /^\d$/;
var NEGATIVE_KEY = /^-$/;

function formatValue(value, places, decimalSeperator, thousandsSeparator) {
  // Absolute value removes the sign so that we can make sure to place it
  // to left when the value is less than zero (e.g. -0.01, not 0.-1)
  var numberValue = Math.abs(Number.parseInt(value, 10));
  var stringValue = Number.isFinite(numberValue) ? numberValue.toString() : '';

  if (stringValue === '' || stringValue === '0') {
    return '';
  }

  var integerPart = places > 0 ? stringValue.slice(0, -places).padStart(1, '0') : stringValue;
  var decimalPart = places > 0 ? stringValue.slice(-places).padStart(places, '0') : '';
  var seperatedIntegerParts = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
  var signValue = value < 0 ? '-' : ''; // Exclude the decimal part if the places value is less than zero to better
  // support zero-decimal currencies.

  var combinedDecimalPart = places > 0 ? "".concat(decimalSeperator).concat(decimalPart) : '';
  return "".concat(signValue).concat(seperatedIntegerParts).concat(combinedDecimalPart);
}

var CurrencyField = _ref => {
  var _textFieldProps$input;

  var {
    currencySymbol = '$',
    decimalPlaces = 2,
    decimalSeperator = '.',
    onChange,
    thousandsSeparator = ',',
    value
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  // Flag to indicate that the negative sign was pressed, but the value is
  // still zero. When a number is pressed, it will make sure the new number is
  // negative. If the negative key is pressed twice it will cancel the flag.
  var [toggleNegative, setToggleNegative] = React__default['default'].useState(false);
  React__default['default'].useEffect(() => {
    if (value && toggleNegative) {
      setToggleNegative(false);
      onChange(null, value * -1);
    }
  }, [value]);
  var displayValue = formatValue(value, decimalPlaces, decimalSeperator, thousandsSeparator);

  function handleKeyDown(event) {
    var currentSignValue = value < 0 ? '-' : '';
    var currentDigits = displayValue.toString().replace(/\D/g, '');
    var currentValue = "".concat(currentSignValue).concat(currentDigits); // Handle deleting keys

    if (event.key === 'Backspace' || event.key === 'Delete') {
      var newValue = parseInt(currentValue.slice(0, -1), 0);
      return onChange(event, Number.isFinite(newValue) ? newValue : 0);
    } // Number keys


    if (INTEGER_KEY.test(event.key)) {
      var _newValue = parseInt("".concat(currentValue).concat(event.key), 0);

      return onChange(event, Number.isFinite(_newValue) ? _newValue : 0);
    } // Negative key


    if (NEGATIVE_KEY.test(event.key)) {
      if (value) {
        // Non-zero values have their sign changed.
        var toggledSignValue = currentSignValue === '-' ? '' : '-';

        var _newValue2 = parseInt("".concat(toggledSignValue).concat(currentDigits).concat(event.key), 0);

        return onChange(event, _newValue2);
      } else {
        // Toggle the negative flag
        setToggleNegative(!toggleNegative);
      }
    }
  }

  var placeholderSign = toggleNegative ? '-' : '';
  var placeholderDecimal = decimalPlaces > 0 ? "".concat(decimalSeperator).concat(''.padStart(decimalPlaces, '0')) : '';
  var placeholder = "".concat(placeholderSign, "0").concat(placeholderDecimal);
  return /*#__PURE__*/React__default['default'].createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
    value: displayValue,
    inputMode: "numeric",
    placeholder: placeholder,
    onKeyDown: handleKeyDown,
    InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.InputProps), {}, {
      startAdornment: /*#__PURE__*/React__default['default'].createElement(InputAdornment__default['default'], {
        position: "start",
        "aria-label": "currency symbol"
      }, currencySymbol)
    }),
    inputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.inputProps), {}, {
      style: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, (_textFieldProps$input = textFieldProps.inputProps) === null || _textFieldProps$input === void 0 ? void 0 : _textFieldProps$input.style), {}, {
        textAlign: 'right'
      })
    })
  }));
};
CurrencyField.propTypes = {
  /** The currency symbol to use. */
  currencySymbol: index.string,

  /** The number of fixed decimal places to show. */
  decimalPlaces: index.number,

  /** Symbol to use for seperating the integer and decimal parts. */
  decimalSeperator: index.string,

  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: this is a generic event, not a change event.
   * @param {number} newValue The integer value of the field.
   */
  onChange: index.func,

  /** Symbol to use for seperating the thousands place. */
  thousandsSeparator: index.string,

  /** The integer value of the input. */
  value: index.oneOfType([index.number, index.string])
};

exports.CurrencyField = CurrencyField;
exports.default = CurrencyField;
